import axios from 'axios';
import {
  PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_BEGIN,
  PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_SUCCESS,
  PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_FAILURE,
  PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCollectionForProjectOnBoard(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_BEGIN,
    });

    const { projectId, version, page } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`;
      if (page || page === 0) {
        url += `?limit=${10}&&page=${page}`;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_SUCCESS,
            data: res.data,
            pageNumber: page,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionForProjectOnBoardError() {
  return {
    type: PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_BEGIN:
      return {
        ...state,
        loadCollectionForProjectOnBoardPending: true,
        loadCollectionForProjectOnBoardError: null,
      };

    case PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_SUCCESS:
      return {
        ...state,
        loadCollectionForProjectOnBoardPending: false,
        loadCollectionForProjectOnBoardError: null,
        projectCollections: action.data.result ? action.data.result : action.data,
        totalCollectionPages: action.data.totalPages
          ? action.data.totalPages
          : state.totalCollectionPages,
        currentCollectionListPage:
          action.pageNumber || action.pageNumber === 0
            ? action.pageNumber
            : state.currentCollectionListPage,
      };

    case PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_FAILURE:
      return {
        ...state,
        loadCollectionForProjectOnBoardPending: false,
        loadCollectionForProjectOnBoardError: action.data.error,
      };

    case PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionForProjectOnBoardError: action.data,
      };

    default:
      return state;
  }
}
